export const STRUCTURES = "/api/pa/structures"
export const STRUCTURE = "/api/pa/structures/:param"
